import { createSelector } from 'reselect'

import { Embed, EmbedConfiguration, EmbedTheme } from '@driftt/api-types'
import { GlobalStore as store } from '@driftt/traffic-control'

const root = (state: any): Embed => state.embed
const getConfiguration = (): EmbedConfiguration => root(store.getState()).configuration
const getConfigurationTheme = (): Partial<EmbedTheme> | undefined => getConfiguration()?.theme

export const getEmbedThemeValue = (property: string): any | undefined =>
  createSelector(getConfigurationTheme, (theme) =>
    theme ? theme[property as keyof Partial<EmbedTheme>] : undefined
  )
